<script setup lang="ts">
import TarotCalculatorCard from "@/views/Calculators/TarotPrediction/components/TarotCalculatorCard.vue";
import { useI18n } from "vue-i18n";
import { ROUTE_NAMES } from "@/constants/routeNames";
import PageTitleWithBackButton from "@/components/PageTitleWithBackButton.vue";

const { t } = useI18n();
</script>

<template>
  <div
    class="flex flex-col md:flex-row h-full w-full px-4 md:mx-0 pt-6 xl:pt-[88px] pb-6 overflow-y-auto no-scrollbar gap-6 md:justify-center"
  >
    <PageTitleWithBackButton
      :page-title="t('calculators.tarot.title')"
      :title-align="'center'"
      class="md:hidden !mb-0"
    />
    <!-- DAILY CARD -->
    <TarotCalculatorCard
      :card-title="t('calculators.tarot.daily-card.title')"
      :card-text="t('calculators.tarot.daily-card.description')"
      :calculator-route="ROUTE_NAMES.TAROT_DAILY"
    />
    <!-- SITUATION PREDICTION -->
    <TarotCalculatorCard
      :card-title="t('calculators.tarot.situation-prediction.title')"
      :card-text="t('calculators.tarot.situation-prediction.description')"
      :calculator-route="ROUTE_NAMES.TAROT_SITUATION"
    />
  </div>
</template>
